<script setup lang="ts">
import { computed, ref, useTemplateRef, type Ref, type ShallowRef } from 'vue';
import { useCart, useState, useUI } from '../store';
import { useRouter } from 'vue-router';
import ConfirmPopup from '../components/ConfirmPopup.vue';

const designerCode = ref("");
const message: Ref<string | null> = ref("");
let messageTimeout: number | null = null;

const { state } = useState();
const { ui } = useUI();
const { cart } = useCart();

const router = useRouter();

const confirmPopup = ref<InstanceType<typeof ConfirmPopup>>();

async function setProductFamily(block: any) {
    if (state.dirty &&
        state.productFamilyCode && 
        state.productFamilyCode !== block.title && 
        !await confirmPopup.value!.confirm()) {
        return;
    }

    state.productFamily = block.title;

    if (state.vertex && state.productFamily == "one")
        state.disableAccessories = true;
    else if (state.vertex && state.productFamily == "seven")
        state.disableAccessories = false;

    router.push(`/${state.productFamilyCode}/worktop`)
}
</script>

<style lang="less" scoped>
    .highlights {

        .image-group {
            position: relative;

            .text-content, .text-content h3 {
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: start;
                padding: 8px;
                gap: 12px;
            }
        }
    }
</style>

<template>
<div class="product-family-view view">
    <div class="wrapper">
        <confirm-popup ref="confirmPopup" :title="ui.t('confirmChangeProductFamilyTitle')" :content="ui.t('confirmChangeProductFamily')"></confirm-popup>
        <div class="section-content">
            <div class="row">
                <div class="section-main col-12">
                    <h2 class="h2" v-html="ui.t('chooseProductFamilyTitle')"></h2>

                    <label class="form-group highlights offset-2">
                        <div class="image-group">
                            <a v-for="block in ui.blocks.productFamilies" 
                                :key="block"
                                :class="{ active: state.productFamily == block.title }"
                                @click="setProductFamily(block)" 
                                class="list-group-item col-5">
                                <div class="container">
                                    <div class="image" :style="{ 'background-image': ui.getBackgroundImageUrl(block.images[0], 600)! }"></div>

                                    <div class="text-content">
                                        <strong v-html="block.text"></strong>
                                        <p v-html="block.additionalText"></p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>
</template>